import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import AkItunesFeed from './AkItunesFeed';
import * as serviceWorker from './serviceWorker';
import packageJson from '../package.json'

const { name: APP_NAME, version: APP_VERSION } = packageJson

navigator.sendBeacon(
  'https://api.apps.austauschkompass.de/' + APP_NAME + '/track',
  JSON.stringify({ version: APP_VERSION, url: document.location.href })
)

const rootEl = document.getElementById('AK-ITUNES-FEED')

if (rootEl) {
  const rawAkConfig = rootEl.dataset.akConfig
  const root = createRoot(rootEl)
  let akConfig

  if (!rawAkConfig) {
    akConfig = {}
  } else {
    akConfig = JSON.parse(rawAkConfig)
  }

  root.render(
    <React.StrictMode>
      <AkItunesFeed {...akConfig} />
    </React.StrictMode>
  )
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
